/// Point should be an array with two numbers in [lon, lat] order
export function getGeoJsonPointGeometry(point) {
    return {
        "type": "Point",
        "coordinates": point,
    };
}
/// Input should be an array of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonMultiPointGeometry(points) {
    return {
        "type": "MultiPoint",
        "coordinates": points,
    };
}
/// Input should be an array of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonLineStringGeometry(points) {
    return {
        "type": "LineString",
        "coordinates": points,
    };
}
/// Input should be an array of arrays of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonMultiLineStringGeometry(points) {
    return {
        "type": "MultiLineString",
        "coordinates": points,
    };
}
/// Input should be an array of arrays of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonPolygonGeometry(points) {
    return {
        "type": "Polygon",
        "coordinates": points,
    };
}
/// Input should be an array polygons.
/// Each polygon should be an array of arrays of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonMultiPolygonGeometry(points) {
    return {
        "type": "MultiPolygon",
        "coordinates": points,
    };
}
export function getGeoJsonCollectionGeometry(geometries) {
    return {
        "type": "GeometryCollection",
        "geometries": geometries,
    };
}
//# sourceMappingURL=geojson.js.map